import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAddNewTaskMutation } from '../../features/tasks/tasksApi';

const TaskForm = ({ projects, teams }) => {
    const navigate = useNavigate()
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [addNewTask, { isError, isSuccess, isLoading }] = useAddNewTaskMutation()

    const onSubmit = data => {
        const teamMember = teams.find(single => single.id === parseInt(data.teamMember))
        const project = projects.find(single => single.id === parseInt(data.projectName))
        const mainData = {
            taskName: data.taskName,
            deadline: data.deadline,
            teamMember,
            project,
        }
        console.log(mainData)
        addNewTask(mainData)
    };

    useEffect(() => {
        if (isSuccess) {
            navigate('/')
        }
        if (isError) {
            console.error({ isError })
        }
    }, [isSuccess, isError])
    return (

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div className="fieldContainer">
                <label for="lws-taskName">Task Name</label>
                <input
                    type="text"
                    name="taskName"
                    id="lws-taskName"
                    {...register("taskName", { required: true })}
                    required
                    placeholder="Implement RTK Query"
                />
            </div>

            <div className="fieldContainer">
                <label>Assign To</label>
                <select   {...register("teamMember", { required: true })} name="teamMember" id="lws-teamMember" required>
                    <option value="" hidden defaultChecked>Select Job</option>
                    {
                        teams?.map(single => <option key={single.id} value={single.id}>{single.name}</option>)
                    }
                </select>
            </div>
            <div className="fieldContainer">
                <label for="lws-projectName">Project Name</label>
                <select id="lws-projectName"   {...register("projectName", { required: true })} name="projectName" required>
                    <option value="" hidden defaultChecked>Select Project</option>
                    {
                        projects?.map(single => <option key={single.id} value={single.id}>{single.projectName}</option>)
                    }
                </select>
            </div>

            <div className="fieldContainer">
                <label for="lws-deadline"   >Deadline</label>
                <input type="date" name="deadline" {...register("deadline", { required: true })} id="lws-deadline" required />
            </div>

            <div className="text-right">
                <button disabled={isLoading} type="submit" className="lws-submit">Save</button>
            </div>
        </form>
    );
};

export default TaskForm;